import Accordion from "components/base/Accordion/Accordion";
import Attachment from "components/base/Attachment/Attachment";
import { useTranslation } from "react-i18next";
import formatCurrency from "utils/formatCurrency";
import useGetAccordionContent from "hooks/content/useGetAccordionContent";
import useGetData from "hooks/api/useGetData";
import { DocumentObject } from "types/api/api";
import { MouseEvent } from "react";

interface ProductAccordionProps {
  productSummary: number;
  productQuantityWatcher: number;
  inputComponent: JSX.Element;
  handleAttachmentClick: (e: MouseEvent, file: DocumentObject) => void;
}

const ProductAccordion = ({
  productSummary,
  inputComponent,
  productQuantityWatcher,
  handleAttachmentClick
}: ProductAccordionProps) => {
  const { t } = useTranslation();
  const { productData, prlData } = useGetData();
  const currency = prlData?.amount?.currency || productData?.amount?.currency;

  const items = useGetAccordionContent({
    inputComponent,
    productQuantityWatcher,
    renderAttachmentComponent: (attachments: DocumentObject[]) => (
      <Attachment items={attachments} onClick={handleAttachmentClick} />
    )
  });

  const content = {
    items,
    headings: [
      {
        title: t("accordion.headingProduct"),
        xs: 4
      },
      {
        title: t("accordion.headingQuantity"),
        xs: 1
      },
      {
        title: t("accordion.headingPrice"),
        xs: 2
      },
      {
        title: t("accordion.headingTotal"),
        xs: 3
      }
    ],

    footer: {
      title: t("accordion.footerTotal"),
      value: formatCurrency(productSummary, currency)
    }
  };

  return <Accordion {...content} currency={currency} />;
};

export default ProductAccordion;
